const createMuiBackdropStyles = () => ({
    styleOverrides: {
        root: {
            background: 'rgba(255, 255, 255, 0.6)',
        },
    },
});

export default createMuiBackdropStyles;
